import springboard from 'springboard';

import initKyselyModule from './kysely_module';
initKyselyModule(springboard);

import initWorkspacesModule from './modules/workspaces_module';
initWorkspacesModule(springboard);
